import React, { useContext, useState } from 'react'
import {
  Footer,
  Search,
  StyledTable,
  TableCell,
  TableContainer,
  TableHeader,
} from './styled'
import useFilteredData from '../../../../hooks/searchHook'
import { Input } from '../../../../components/common/Input'
import { Button } from '../../../../components/common/Button'
import { CheckCircle, MagnifyingGlass, NotePencil } from '@phosphor-icons/react'
import { Modal } from '../../../../components/Modal'
import api from '../../../../services/api'

interface BaseRegisterTableProps {
  editOnClick: (id: string) => void
  deleteOnClick: (id: string) => void // Add the correct type for deleteOnClick if needed
  data: any
}

interface DeleteId {
  id: string
}

export const BaseRegisterTable = ({
  editOnClick,
  data,
}: BaseRegisterTableProps) => {
  console.log('🚀 ~ data:', data)
  const [search, setSearch] = useState('')
  const [deleteBase, setDeleteBase] = useState<boolean>(false)
  const [deleted, setDeleted] = useState<boolean>(false)
  const [deleteId, setDeleteId] = useState<DeleteId>()
  const [baseName, setBaseName] = useState('')
  const [outpost, setOutpost] = useState('')

  const handleDelete = async () => {
    try {
      await api.delete('/v1/dashboard/base/delete', { data: { id: deleteId } })
      setDeleteBase((prev) => !prev)
      setDeleted((prev) => !prev)
    } catch (error) {
      console.error('Erro ao atualizar:', error)
    }
  }
  const { filteredData, filterData } = useFilteredData(data)

  const handleSearchChange = (e) => {
    setSearch(e.target.value)
    filterData(e.target.value)
  }

  return (
    <>
      <TableContainer>
        <div>
          <Search
            onSubmit={(e) => {
              e.preventDefault()
              setDeleteBase((prev) => !prev)
            }}
          >
            <span>Pesquisar</span>
            <Input.Root>
              <Input.Wrapper
                borderColor="#CECECE"
                backgroundColor="#F7F7F7"
                outlineColor=""
              >
                <Input.Content
                  id=""
                  onChange={handleSearchChange}
                  type="text"
                  value={search}
                  placeholder="Base"
                />
                <Input.Icon>
                  <MagnifyingGlass size={16} color="#494949" />
                </Input.Icon>
              </Input.Wrapper>
            </Input.Root>
          </Search>
        </div>

        <StyledTable>
          <thead>
            <tr>
              <TableHeader>Base</TableHeader>
              <TableHeader>Posto</TableHeader>
              <TableHeader>Endereco</TableHeader>
              <TableHeader>Editar base</TableHeader>
              <TableHeader>Remover linha</TableHeader>
            </tr>
          </thead>
          <tbody>
            {!data ? <tr>Nenhum dado encontrado</tr> : <></>}
            {filteredData.map((data) => {
              return (
                <tr key={data.id}>
                  <TableCell>{data.base}</TableCell>
                  <TableCell>{data.outpost}</TableCell>
                  <TableCell>{`${data.Address[0].address} - ${data.Address[0].burgh} - ${data.Address[0].city}`}</TableCell>
                  <TableCell>
                    <Button.Root
                      onClick={() => editOnClick(data.id || '')}
                      backgroundColor="#00517D"
                      type="button"
                    >
                      <Button.Content title="Editar" color="#fff" />
                      <Button.Icon>
                        <NotePencil size={15} color="#fff" weight="fill" />
                      </Button.Icon>
                    </Button.Root>
                  </TableCell>
                  <TableCell>
                    <Button.Root
                      onClick={() => {
                        setDeleteId(data.id || '')
                        setDeleteBase((prev) => !prev)
                        setOutpost(data.base)
                        setBaseName(data.outpost)
                      }}
                      backgroundColor="#770A00"
                      type="button"
                    >
                      <Button.Content title="Remover" color="#fff" />
                    </Button.Root>
                  </TableCell>
                </tr>
              )
            })}
          </tbody>
        </StyledTable>
        <Footer>
          <span>{`Listando ${filteredData.length} bases`}</span>
        </Footer>

        {/* Modals Delete User */}
        <Modal.Root
          backgroundcolor="#fff"
          borderradius="6px"
          width="fit-content"
          height="fit-content"
          left="50%"
          top="50%"
          open={deleteBase}
          setIsOpenController={() => setDeleteBase((prev) => !prev)}
        >
          <Modal.Header onclick={() => setDeleteBase((prev) => !prev)} />
          <Modal.Content
            value="Você deseja realmente deletar?"
            subvalue={`Você removeu o cadastro da base ${outpost} | ${baseName}. da plataforma.`}
          />
          <Modal.Footer>
            <Button.Root
              backgroundColor="#fff"
              border="1px solid #770A00"
              onClick={() => setDeleteBase((prev) => !prev)}
            >
              <Button.Content title="Não, cancelar" color="#770A00" />
            </Button.Root>
            <Button.Root backgroundColor="#770A00" onClick={handleDelete}>
              <Button.Content title="Deletar" color="#fff" />
            </Button.Root>
          </Modal.Footer>
        </Modal.Root>
        <Modal.Root
          backgroundcolor="#fff"
          borderradius="6px"
          height="fit-content"
          width="25%"
          left="50%"
          top="50%"
          open={deleted}
          setIsOpenController={() => location.reload()}
        >
          <Modal.Header onclick={() => setDeleted((prev) => !prev)} />
          <Modal.Icon icon={<CheckCircle size={60} color="#770A00" />} />
          <Modal.Content
            value="Base removida"
            subvalue={`Você removeu o cadastro da base ${outpost} | ${baseName}. da plataforma.`}
          />
          <Modal.Footer>
            <Button.Root
              backgroundColor="#770A00"
              onClick={() => location.reload()}
            >
              <Button.Content title="Voltar para página" color="#fff" />
            </Button.Root>
          </Modal.Footer>
        </Modal.Root>
        {/* Modals Delete User */}
      </TableContainer>
    </>
  )
}
